import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/Home/Logo.png';
import Submitbtn from '../buttons/Submitbtn';


function UnAuthNav() {
  return (
    <>
      <Box sx={{
        width: "100%",
        height: "15vh",
        backgroundColor: "#fff",
        display: { md: "flex", xs: "none" },
        justifyContent: "space-between",
        px: "5%",
        alignItems: "center",
        position: "fixed",
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        zIndex: "10",
      }}>
        <Box sx={{
          width: "30%",
          height: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
          <Link to="/catalogues" style={{ textDecoration: "none", color: "rgba(45, 44, 44, 1)" }}>
            <Typography>Catalogues</Typography>
          </Link>
          <Link to="/About" style={{ textDecoration: "none", color: "rgba(45, 44, 44, 1)" }}>
            <Typography>About Us</Typography>
          </Link>
          <Link to="/Contactus" style={{ textDecoration: "none", color: "rgba(45, 44, 44, 1)" }}>
            <Typography>Contact Us</Typography>
          </Link>
        </Box>
        <Box sx={{
          width: "20%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
          <Box sx={{ height: "60%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Link to="/" style={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
              <img
                src={Logo}
                alt="Logo"
                style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
              />
            </Link>
          </Box>
        </Box>
        
        <Box sx={{
          width: "30%",
          height: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "20px",
        }}>
          <Box>
            <Link to="/login" style={{ textDecoration: "none" }}>
              <Submitbtn name={"Login"} color={"white"} borderRadius={"20px"} width={"120px"} />
            </Link>
          </Box>
          <Box>
            <Link to="/register" style={{ textDecoration: "none" }}>
              <Submitbtn name={"Signup"} color={"white"} borderRadius={"20px"} width={"120px"} />
            </Link>
          </Box>
        </Box>
      </Box>
      <Box sx={{
        width: "100%",
        height: "15vh",
        display: { md: "flex", xs: "none" }
      }}></Box>
    </>
  );
}

export default UnAuthNav;
